module.exports = __webpack_public_path__ + "static/media/game_cover_archero2@768.748048a7.png";